import React from 'react';
import {
  EVPaper, EVGrid, EVSkeleton,
} from 'lib/components';
import AddressVerificationStyles from '../AddressVerificationStyles';

function AddressVerificationLoader() {
  const classes = AddressVerificationStyles();
  return (
    <EVGrid className={classes.addressVerificationContainer}>
      <EVPaper elevation={0} className={classes.addressVerificationPaper}>
        <EVSkeleton style={{ height: '100px', width: '100%', borderRadius: '6px' }} animation="wave" variant="rect" />
        <EVGrid container className={classes.reportAddressContainer}>
          <EVSkeleton style={{ height: '24px', width: '30%', borderRadius: '6px' }} animation="wave" variant="rect" />
          <EVSkeleton style={{ height: '24px', width: '50%', borderRadius: '6px' }} animation="wave" variant="rect" />
        </EVGrid>
      </EVPaper>
      <EVPaper elevation={0} className={classes.mapPinVerificationPaper}>
        <EVGrid className={classes.mapContainer}>
          <EVSkeleton style={{ height: '100%', width: '100%', borderRadius: '6px' }} animation="wave" variant="rect" />
        </EVGrid>
      </EVPaper>
    </EVGrid>
  );
}

export default AddressVerificationLoader;
